<ng-container>{{ (amount !== 1 ? "fma_unit_zero" : "fma_unit_one") | translate }} </ng-container>
